export default {
      id: "wealth-creation-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#wealth-creation",
      toString: function () {
        return this.url;
      }
    }